import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/down.png'
import _imports_1 from '../../assets/performance/footer.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-05b96fd7")

_pushScopeId("data-v-05b96fd7")
const _hoisted_1 = {
  class: "Ecard",
  id: "trendChart"
}
const _hoisted_2 = { class: "testMain" }
const _hoisted_3 = { class: "fitter_title" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, " 删除 ", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 编辑 ")
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("发送报告")
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "按任务生成报告", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, "手动生成报告", -1)
const _hoisted_13 = { style: {"display":"flex","justify-content":"space-between","margin-top":"10px"} }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, "清除缓存", -1)
const _hoisted_16 = { class: "dialogTitle" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("手动生成报告-按任务")
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "el-icon-message-solid" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("生成报告")
const _hoisted_20 = { class: "dialogTitle" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", null, "手动生成报告", -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode("生成报告")
const _hoisted_23 = {
  key: 0,
  class: "editRecipient"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 可按如下任一形式批量添加： ")
const _hoisted_25 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode("1、zhangsan;lisi;wangwu ")
const _hoisted_27 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode("2、zhangsan(张三);lisi(李四);wangwu(王五) ")
const _hoisted_29 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode("3、zhangsan(张三) <zhangsan@tencent.com>;lisi(李四) <lisi@tencent.com>; wangwu(王五) <wangwu@tencent.com> ")
const _hoisted_31 = /*#__PURE__*/_createVNode("span", null, "发送报告", -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_33 = {
  class: "versionGeneration versionGeneration2",
  style: {}
}
const _hoisted_34 = { class: "copyVal" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("复制数据")
const _hoisted_36 = { id: "perf_report" }
const _hoisted_37 = { class: "spacName" }
const _hoisted_38 = { class: "mainContent" }
const _hoisted_39 = { class: "spacName" }
const _hoisted_40 = { class: "gameTable" }
const _hoisted_41 = {
  rowspan: 3,
  class: "gameIcon"
}
const _hoisted_42 = {
  colspan: 3,
  class: "game_name"
}
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" 测试版本: ")
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" 报告创建时间: ")
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" 创建者: ")
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" 风险等级: ")
const _hoisted_47 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createTextVNode(" 测试类型: "),
  /*#__PURE__*/_createVNode("span", null, "客户端性能自动化测试")
], -1)
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" 测试平台: ")
const _hoisted_49 = { class: "corePerformance" }
const _hoisted_50 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("核心指标风险详情")
], -1)
const _hoisted_51 = { class: "spacName" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = /*#__PURE__*/_createTextVNode("对比")
const _hoisted_55 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_56 = {
  key: 1,
  style: {"color":"#00b050"}
}
const _hoisted_57 = { class: "corePerformance" }
const _hoisted_58 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("自动化路径图")
], -1)
const _hoisted_59 = { class: "spacName" }
const _hoisted_60 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_61 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("函数耗时")
], -1)
const _hoisted_62 = { class: "mt-5" }
const _hoisted_63 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("核心指标性能趋势")
], -1)
const _hoisted_64 = { class: "spacName" }
const _hoisted_65 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("span", { class: "labelStyle" }, "版本数据对比")
], -1)
const _hoisted_66 = /*#__PURE__*/_createVNode("div", {
  id: "contrast",
  style: {"width":"100%","height":"350px","display":"flex"}
}, [
  /*#__PURE__*/_createVNode("div", {
    id: "contrast_left",
    style: {"width":"50%","height":"350px"}
  }),
  /*#__PURE__*/_createVNode("div", {
    id: "contrast_right",
    style: {"width":"50%","height":"350px"}
  })
], -1)
const _hoisted_67 = { class: "labelStyle" }
const _hoisted_68 = { class: "labelStyle2" }
const _hoisted_69 = { class: "detailedTest" }
const _hoisted_70 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("详细测试数据")
], -1)
const _hoisted_71 = { class: "describe" }
const _hoisted_72 = /*#__PURE__*/_createVNode("span", null, "灰色", -1)
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { class: "detailedTestTable" }
const _hoisted_75 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_76 = { class: "outerLayerTable" }
const _hoisted_77 = { class: "Table_Left" }
const _hoisted_78 = { colspan: 2 }
const _hoisted_79 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("td", { colspan: 2 }, "性能数据链接")
], -1)
const _hoisted_80 = { class: "Table_Right" }
const _hoisted_81 = { id: "Table_Right_div" }
const _hoisted_82 = { class: "Table_Right_in" }
const _hoisted_83 = { colspan: 3 }
const _hoisted_84 = /*#__PURE__*/_createVNode("td", null, "old", -1)
const _hoisted_85 = /*#__PURE__*/_createVNode("td", null, "new", -1)
const _hoisted_86 = /*#__PURE__*/_createVNode("td", null, "趋势", -1)
const _hoisted_87 = { key: 0 }
const _hoisted_88 = { key: 1 }
const _hoisted_89 = { key: 2 }
const _hoisted_90 = { key: 3 }
const _hoisted_91 = /*#__PURE__*/_createVNode("td", null, "--", -1)
const _hoisted_92 = { key: 1 }
const _hoisted_93 = /*#__PURE__*/_createVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_empty = _resolveComponent("el-empty")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode("div", _hoisted_3, [
                    _createVNode(_component_el_form, {
                      inline: true,
                      size: "mini",
                      class: "spacForm queryReport"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { label: "报告名称" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.name_search,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.name_search = $event)),
                              placeholder: "请选择",
                              onChange: _ctx.change_name_search
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.nameList, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: item.report_name,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_popconfirm, {
                              onConfirm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleDelete())),
                              title: "确认删除该报告？",
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  size: "mini",
                                  type: "info",
                                  disabled: _ctx.get_is_super
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_4
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              class: "editBtn",
                              size: "mini",
                              onClick: _ctx.handleEdit
                            }, {
                              default: _withId(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_el_dialog, {
                              modelValue: _ctx.dialogFormVisible1,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialogFormVisible1 = $event))
                            }, {
                              footer: _withId(() => [
                                _createVNode("span", _hoisted_6, [
                                  _createVNode(_component_el_button, {
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogFormVisible1 = false))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_7
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: _ctx.dialogFormVisible2
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_8
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ])
                              ]),
                              default: _withId(() => [
                                _withDirectives(_createVNode(_component_el_form, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_form_item, {
                                      class: "reportName",
                                      label: "报告名称",
                                      "label-width": _ctx.formLabelWidth
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_input, {
                                          class: "report-input",
                                          modelValue: _ctx.form1.name,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form1.name = $event)),
                                          autocomplete: "off"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }, 8, ["label-width"])
                                  ]),
                                  _: 1
                                }, 512), [
                                  [_vShow, _ctx.dialogFormVisible1]
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.sendOut,
                              class: "down_img"
                            }, {
                              default: _withId(() => [
                                _hoisted_9,
                                _hoisted_10
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode("div", null, [
                      _createVNode(_component_el_button, {
                        size: "mini",
                        type: "primary",
                        onClick: _ctx.generateReportsManuallyByTask,
                        disabled: _ctx.get_is_super,
                        style: {"height":"28px"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_tooltip, {
                            effect: "dark",
                            content: "暂无管理员权限",
                            placement: "top",
                            disabled: !_ctx.get_is_super
                          }, {
                            default: _withId(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"]),
                      _createVNode(_component_el_button, {
                        size: "mini",
                        type: "primary",
                        onClick: _ctx.generateReportsManually,
                        disabled: _ctx.get_is_super,
                        style: {"height":"28px"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_tooltip, {
                            effect: "dark",
                            content: "暂无管理员权限",
                            placement: "top",
                            disabled: !_ctx.get_is_super
                          }, {
                            default: _withId(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"]),
                      _createVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createVNode(_component_el_button, {
                          size: "mini",
                          type: "primary",
                          onClick: _ctx.clear,
                          disabled: _ctx.get_is_super,
                          style: {"height":"28px","margin-left":"auto"}
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_tooltip, {
                              effect: "dark",
                              content: "暂无管理员权限",
                              placement: "top",
                              disabled: !_ctx.get_is_super
                            }, {
                              default: _withId(() => [
                                _hoisted_15
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled"])
                      ])
                    ])
                  ]),
                  _createVNode(_component_el_dialog, {
                    modelValue: _ctx.dialogFormVisibleByTask,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogFormVisibleByTask = $event)),
                    width: "790px"
                  }, {
                    title: _withId(() => [
                      _createVNode("div", _hoisted_16, [
                        _createVNode("span", null, [
                          _hoisted_17,
                          _createVNode(_component_el_tooltip, {
                            class: "item",
                            effect: "dark",
                            content: "如只选择测试任务, 则按照任务完成自动生成报告的逻辑生成一份报告",
                            placement: "top"
                          }, {
                            default: _withId(() => [
                              _hoisted_18
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_component_el_divider)
                      ])
                    ]),
                    footer: _withId(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.generateReportByTask,
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _hoisted_19
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        inline: true,
                        model: _ctx.generateReportVersion,
                        "label-position": "top",
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "对比任务" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.oldEdition,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.generateReportVersion.oldEdition = $event)),
                                id: "old_version",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.RecentTaskrecord, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "测试任务" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.newEdition,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.generateReportVersion.newEdition = $event)),
                                id: "new_version",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.RecentTaskrecord, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_dialog, {
                    modelValue: _ctx.dialogFormVisible,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.dialogFormVisible = $event)),
                    width: "790px"
                  }, {
                    title: _withId(() => [
                      _createVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createVNode(_component_el_divider)
                      ])
                    ]),
                    footer: _withId(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.generateReport,
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _hoisted_22
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        inline: true,
                        model: _ctx.generateReportVersion,
                        "label-position": "top",
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "旧版本" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.oldEdition,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.generateReportVersion.oldEdition = $event)),
                                id: "old_version",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_version_options, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "新版本" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.newEdition,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.generateReportVersion.newEdition = $event)),
                                id: "new_version",
                                placeholder: "请选择",
                                onChange: _ctx.selectVersion
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_version_options, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          }),
                          _withDirectives(_createVNode(_component_el_form_item, { label: "场景" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.scenetion,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.generateReportVersion.scenetion = $event)),
                                multiple: "",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_scene_version, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.scene_id_id,
                                      label: item.scene_id__chinese,
                                      value: item.scene_id_id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.localProject != 34 && _ctx.localProject != 40]
                          ])
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.edit)
                    ? (_openBlock(), _createBlock("div", _hoisted_23, [
                        _createVNode(_component_el_form, {
                          "label-position": "left",
                          "label-width": "100px",
                          model: _ctx.formMail,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "邮件标题" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.title,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.formMail.title = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件发件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _createTextVNode(" 指定的邮件发件人需要位于公司TOF发件人名单,否则无法发送邮件。默认邮件发件人" + _toDisplayString(_ctx.formMail.Sender), 1)
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.Sender,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.formMail.Sender = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件收件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _hoisted_24,
                                    _hoisted_25,
                                    _hoisted_26,
                                    _hoisted_27,
                                    _hoisted_28,
                                    _hoisted_29,
                                    _hoisted_30
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.addressee,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.formMail.addressee = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件抄送人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.CC_List,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.formMail.CC_List = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_popconfirm, {
                              title: "确认发送报告吗？",
                              onConfirm: _cache[17] || (_cache[17] = ($event: any) => (_ctx.save_report(false))),
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  disabled: _ctx.get_is_super,
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_31
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "info",
                              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.edit = false))
                            }, {
                              default: _withId(() => [
                                _hoisted_32
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_33, [
                    _createVNode("p", null, [
                      _createVNode("b", null, _toDisplayString("版本号: " +
                    _ctx.new_report.new_version +
                    " - " +
                    "时间: " +
                    _ctx.new_report.create_date), 1)
                    ]),
                    _createVNode("div", _hoisted_34, [
                      (
                    !_ctx.get_is_super &&
                    (_ctx.localProject === 34 ||
                      _ctx.localProject === 12 ||
                      _ctx.localProject === 47 ||
                      _ctx.localProject === 36 ||
                      _ctx.localProject === 40)
                  )
                        ? (_openBlock(), _createBlock(_component_el_form, {
                            key: 0,
                            inline: true,
                            model: _ctx.copyVal,
                            size: "mini"
                          }, {
                            default: _withId(() => [
                              (_ctx.new_report.task_record_id != null)
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 0,
                                    label: "当前记录id:",
                                    class: "iTemWidth2"
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(_ctx.new_report.task_record_id), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_form_item, {
                                label: "任务记录id",
                                class: "iTemWidth"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    onChange: _ctx.equipmentUpdate,
                                    modelValue: _ctx.copyVal.taskRecordId,
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.copyVal.taskRecordId = $event)),
                                    placeholder: "请选择任务记录id",
                                    filterable: ""
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.TaskRecordQuery, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.id,
                                          label: item.id,
                                          value: item.id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, {
                                label: "设备数据",
                                class: "iTemWidth"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.copyVal.deviceVal,
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.copyVal.deviceVal = $event)),
                                    placeholder: "请选择设备数据",
                                    filterable: ""
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.TaskRecordDevices, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.id,
                                          label: item.model.model,
                                          value: item.id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_popconfirm, {
                                    title: "确认复制数据吗？",
                                    onConfirm: _ctx.CopyBtn,
                                    placement: "top"
                                  }, {
                                    reference: _withId(() => [
                                      _createVNode(_component_el_button, {
                                        type: "primary",
                                        disabled: _ctx.interfaceDisabled
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_35
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]),
                                    _: 1
                                  }, 8, ["onConfirm"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["model"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_36, [
                    _withDirectives(_createVNode("div", _hoisted_37, [
                      _createVNode("img", {
                        class: "banner",
                        src: _ctx.get_banner,
                        alt: ""
                      }, null, 8, ["src"])
                    ], 512), [
                      [_directive_loading, _ctx.loading]
                    ]),
                    _createVNode("div", _hoisted_38, [
                      _createVNode("div", _hoisted_39, [
                        _withDirectives(_createVNode("table", _hoisted_40, [
                          _createVNode("tr", null, [
                            _createVNode("td", _hoisted_41, [
                              _createVNode("img", {
                                src: _ctx.get_core_data.project.icon
                              }, null, 8, ["src"])
                            ]),
                            _createVNode("td", _hoisted_42, " 【" + _toDisplayString(_ctx.get_core_data.project.project_name) + "】 ", 1)
                          ]),
                          _createVNode("tr", null, [
                            _createVNode("td", null, [
                              _hoisted_43,
                              _createVNode("span", null, _toDisplayString(_ctx.new_report.new_version), 1)
                            ]),
                            _createVNode("td", null, [
                              _hoisted_44,
                              _createVNode("span", null, _toDisplayString(_ctx.new_report.create_date), 1)
                            ]),
                            _createVNode("td", null, [
                              _hoisted_45,
                              _createVNode("span", null, _toDisplayString(_ctx.new_report.creator), 1)
                            ])
                          ]),
                          _createVNode("tr", null, [
                            _createVNode("td", null, [
                              _hoisted_46,
                              _createVNode("span", {
                                class: 
                            _ctx.new_report.risk === '高风险'
                              ? 'com_risk_red'
                              : 'com_risk_green'
                          
                              }, _toDisplayString(_ctx.new_report.risk), 3)
                            ]),
                            _hoisted_47,
                            _createVNode("td", null, [
                              _hoisted_48,
                              _createVNode("span", null, _toDisplayString(_ctx.modelVal), 1)
                            ])
                          ])
                        ], 512), [
                          [_directive_loading, _ctx.loading]
                        ])
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_49, [
                        _hoisted_50,
                        _createVNode("div", _hoisted_51, [
                          (_ctx.corePerformance.length > 0)
                            ? (_openBlock(), _createBlock("div", _hoisted_52, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.corePerformance, (item) => {
                                  return (_openBlock(), _createBlock(_Fragment, {
                                    key: item.title
                                  }, [
                                    (_ctx.corePerformance.length > 1)
                                      ? (_openBlock(), _createBlock("h6", _hoisted_53, _toDisplayString(item.title), 1))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_set.content.core_index, (setting) => {
                                      return (_openBlock(), _createBlock(_component_el_table, {
                                        data: item.data,
                                        key: setting
                                      }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_table_column, {
                                            prop: "scene",
                                            label: "测试场景"
                                          }, {
                                            default: _withId((scope) => [
                                              _createVNode("span", null, _toDisplayString(scope.row?.scene), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_table_column, {
                                            label: 
                              _ctx.get_field(setting) +
                              '趋势(vs. ' +
                              _ctx.old_text() +
                              ')'
                            
                                          }, {
                                            default: _withId(() => [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.compare, (device, index) => {
                                                return (_openBlock(), _createBlock(_component_el_table_column, {
                                                  key: Number(index),
                                                  label: _ctx.get_device_label(device, Number(index))
                                                }, {
                                                  default: _withId((scope) => [
                                                    _createVNode(_component_el_tooltip, {
                                                      effect: "dark",
                                                      placement: "top"
                                                    }, {
                                                      content: _withId(() => [
                                                        _createVNode("span", {
                                                          style: {"cursor":"pointer"},
                                                          onClick: ($event: any) => (
                                        _ctx.target(scope.row.new[index].data?.url)
                                      )
                                                        }, _toDisplayString(scope.row.new[index].data
                                          ?.game_version || "--"), 9, ["onClick"]),
                                                        _hoisted_54,
                                                        _createVNode("span", {
                                                          style: {"cursor":"pointer"},
                                                          onClick: ($event: any) => (
                                        _ctx.target(scope.row.old[index].data?.url)
                                      )
                                                        }, _toDisplayString(scope.row.old[index].data
                                          ?.game_version || "--"), 9, ["onClick"])
                                                      ]),
                                                      default: _withId(() => [
                                                        _createVNode("span", {
                                                          style: 
                                      _ctx.compore_num(
                                        scope.row.new[index]?.data?.[setting],
                                        scope.row.old[index]?.data?.[setting],
                                        setting,
                                        scope.row,
                                        scope.row.new[index]
                                      )[3]
                                    
                                                        }, _toDisplayString(scope.row.new[index]?.data?.[setting] ||
                                      "--"), 5)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    (
                                    _ctx.compore_num(
                                      scope.row.new[index]?.data?.[setting],
                                      scope.row.old[index]?.data?.[setting],
                                      setting,
                                      scope.row,
                                      scope.row.new[index]
                                    )[0] !== ''
                                  )
                                                      ? (_openBlock(), _createBlock("span", {
                                                          key: 0,
                                                          id: "blodTypeId",
                                                          style: 
                                    'color:' +
                                    _ctx.compore_num(
                                      scope.row.new[index]?.data?.[setting],
                                      scope.row.old[index]?.data?.[setting],
                                      setting,
                                      scope.row,
                                      scope.row.new[index]
                                    )[2]
                                  
                                                        }, _toDisplayString(_ctx.compore_num(
                                      scope.row.new[index]?.data?.[setting],
                                      scope.row.old[index]?.data?.[setting],
                                      setting,
                                      scope.row,
                                      scope.row.new[index]
                                    )[0]), 5))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["label"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["label"]),
                                          _createVNode(_component_el_table_column, {
                                            prop: "trend",
                                            label: "趋势风险"
                                          }, {
                                            default: _withId((scope) => [
                                              (scope.row?.[setting] === '高风险')
                                                ? (_openBlock(), _createBlock("span", _hoisted_55, _toDisplayString(scope.row?.[setting]), 1))
                                                : (_openBlock(), _createBlock("span", _hoisted_56, "低风险"))
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["data"]))
                                    }), 128))
                                  ], 64))
                                }), 128))
                              ]))
                            : (_openBlock(), _createBlock(_component_el_empty, {
                                key: 1,
                                description: "无数据"
                              }))
                        ])
                      ], 512), [
                        [_directive_loading, _ctx.loading]
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_57, [
                        _hoisted_58,
                        _createVNode("div", null, [
                          _createVNode(_component_el_form, { inline: true }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, { label: "选择场景" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.selected_scene1,
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.selected_scene1 = $event)),
                                    size: "mini",
                                    filterable: "",
                                    placeholder: "请选择场景",
                                    onChange: _ctx.selectSceneChange1
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options1, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.scene_id,
                                          label: item.chinese,
                                          value: item.scene_id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode("div", _hoisted_59, [
                          _createVNode(_component_el_table, {
                            data: _ctx.imgData,
                            border: ""
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, {
                                prop: "device_name",
                                label: "测试机型",
                                width: "150"
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "trajectory",
                                label: ""
                              }, {
                                default: _withId((scope) => [
                                  _createVNode(_component_el_image, {
                                    style: {"width":"100%","height":"100%"},
                                    src: scope.row.trajectory
                                  }, null, 8, ["src"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "fps",
                                label: ""
                              }, {
                                default: _withId((scope) => [
                                  _createVNode(_component_el_image, {
                                    style: {"width":"100%","height":"100%"},
                                    src: scope.row.fps
                                  }, null, 8, ["src"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["data"])
                        ])
                      ], 512), [
                        [_directive_loading, _ctx.loading],
                        [_vShow, _ctx.localProject === 12]
                      ]),
                      (_ctx.localProject == 63)
                        ? (_openBlock(), _createBlock("div", _hoisted_60, [
                            _hoisted_61,
                            _createVNode(_component_el_table, {
                              size: "mini",
                              data: _ctx.customData,
                              class: "mt-2",
                              border: "",
                              "header-cell-style": {
                      background: '#5D99D5',
                      color: '#fff'
                    }
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_table_column, {
                                  prop: "func_name",
                                  label: "函数",
                                  width: "200"
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "duration",
                                  label: "执行耗时",
                                  width: "50"
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "label",
                                  label: "标签",
                                  width: "200"
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "change",
                                  label: "对比上个版本变化",
                                  width: "100",
                                  align: "center"
                                })
                              ]),
                              _: 1
                            }, 8, ["data"])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_62, [
                        _hoisted_63,
                        _createVNode("div", null, [
                          _createVNode(_component_el_form, { inline: true }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, { label: "选择场景" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.selected_scene,
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.selected_scene = $event)),
                                    size: "mini",
                                    filterable: "",
                                    placeholder: "请选择场景",
                                    onChange: _ctx.selectSceneChange
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.scene_id,
                                          label: item.chinese,
                                          value: item.scene_id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode("div", _hoisted_64, [
                          (_ctx.subChart.length !== _ctx.target_types.length)
                            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                (_ctx.FPStrendShow)
                                  ? (_openBlock(), _createBlock(_component_el_card, {
                                      key: 0,
                                      class: "FPStrend"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_65,
                                        _hoisted_66
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.target_types, (item, index) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "FPStrend",
                                    style: {"width":"100%","height":"350px"},
                                    key: index
                                  }, [
                                    _withDirectives(_createVNode(_component_el_card, null, {
                                      default: _withId(() => [
                                        _createVNode("p", null, [
                                          _createVNode("span", _hoisted_67, _toDisplayString(item.label) + "趋势图", 1),
                                          _createVNode("span", _hoisted_68, "     场景：" + _toDisplayString(_ctx.get_scene_chinese), 1)
                                        ]),
                                        _createVNode("div", {
                                          id: 'performance_line' + index,
                                          class: "echartHeight",
                                          style: {"width":"100%","height":"350px"}
                                        }, null, 8, ["id"])
                                      ]),
                                      _: 2
                                    }, 1536), [
                                      [_directive_loading, _ctx.line_loading]
                                    ])
                                  ]))
                                }), 128))
                              ], 64))
                            : (_openBlock(), _createBlock(_component_el_empty, {
                                key: 1,
                                description: "无数据"
                              }))
                        ])
                      ]),
                      _createVNode("div", _hoisted_69, [
                        _hoisted_70,
                        _createVNode("p", _hoisted_71, [
                          _hoisted_72,
                          _createTextVNode("为上个版本数据，白色为当前内网最新版本数据。  当前版本: " + _toDisplayString(_ctx.new_text()) + "   对比版本: " + _toDisplayString(_ctx.old_text()), 1)
                        ]),
                        (_ctx.get_core_data.report_list2.length > 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_73, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_core_data.report_list2, (scene) => {
                                return _withDirectives((_openBlock(), _createBlock("div", {
                                  key: scene.scene_id,
                                  class: "spacName2"
                                }, [
                                  _createVNode("div", _hoisted_74, [
                                    _createVNode("h5", null, [
                                      _hoisted_75,
                                      _createTextVNode(" " + _toDisplayString(scene.scene), 1)
                                    ]),
                                    _createVNode("table", _hoisted_76, [
                                      _createVNode("tr", null, [
                                        _createVNode("td", _hoisted_77, [
                                          _createVNode("table", null, [
                                            _createVNode("tr", null, [
                                              _createVNode("td", _hoisted_78, _toDisplayString(scene.scene), 1)
                                            ]),
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.indexClassification(
                                    scene.custom_index
                                  ), (item, index) => {
                                              return (_openBlock(), _createBlock("tr", { key: index }, [
                                                _createVNode("td", {
                                                  style: {"width":"175px","overflow":"hidden","max-width":"175px"},
                                                  title: item.dataItem
                                                }, _toDisplayString(item.dataItem), 9, ["title"])
                                              ]))
                                            }), 128)),
                                            _hoisted_79,
                                            _createVNode("tr", null, [
                                              _createVNode("td", {
                                                colspan: 2,
                                                class: _ctx.scroll ? 'scrollTD2' : 'scrollTD'
                                              }, null, 2)
                                            ])
                                          ])
                                        ]),
                                        _createVNode("td", _hoisted_80, [
                                          _createVNode("div", _hoisted_81, [
                                            _createVNode("table", null, [
                                              _createVNode("tr", null, [
                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(scene.device_list, (device, d_index) => {
                                                  return (_openBlock(), _createBlock("td", { key: d_index }, [
                                                    _createVNode("table", _hoisted_82, [
                                                      _createVNode("tr", null, [
                                                        _createVNode("td", _hoisted_83, _toDisplayString(device), 1)
                                                      ]),
                                                      _createVNode("tr", null, [
                                                        _createVNode(_component_el_tooltip, {
                                                          effect: "dark",
                                                          placement: "top"
                                                        }, {
                                                          content: _withId(() => [
                                                            _createVNode("span", null, _toDisplayString(scene.old[d_index].data
                                                  ?.game_version || "--"), 1)
                                                          ]),
                                                          default: _withId(() => [
                                                            _hoisted_84
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_el_tooltip, {
                                                          effect: "dark",
                                                          placement: "top"
                                                        }, {
                                                          content: _withId(() => [
                                                            _createVNode("span", null, _toDisplayString(scene.new[d_index].data
                                                  ?.game_version || "--"), 1)
                                                          ]),
                                                          default: _withId(() => [
                                                            _hoisted_85
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _hoisted_86
                                                      ]),
                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.all_index(
                                            scene.custom_index
                                          ), (i, i_index) => {
                                                        return (_openBlock(), _createBlock("tr", { key: i_index }, [
                                                          (
                                              scene.old[d_index].data?.[i] !==
                                                null &&
                                              scene.old[d_index].data?.[i] !==
                                                '' &&
                                              scene.old[d_index].data?.[i] !==
                                                undefined
                                            )
                                                            ? (_openBlock(), _createBlock("td", _hoisted_87, _toDisplayString(scene.old[d_index].data?.[i]), 1))
                                                            : (_openBlock(), _createBlock("td", _hoisted_88, "--")),
                                                          (
                                              scene.new[d_index].data?.[i] !==
                                                '' &&
                                              scene.new[d_index].data?.[i] !==
                                                null &&
                                              scene.new[d_index].data?.[i] !==
                                                undefined
                                            )
                                                            ? (_openBlock(), _createBlock("td", _hoisted_89, _toDisplayString(scene.new[d_index].data?.[i]), 1))
                                                            : (_openBlock(), _createBlock("td", _hoisted_90, "--")),
                                                          _createVNode("td", {
                                                            style: 
                                              'color: ' +
                                              _ctx.compore_num(
                                                scene.new[d_index].data?.[i],
                                                scene.old[d_index].data?.[i],
                                                i
                                              )[4]
                                            
                                                          }, _toDisplayString(_ctx.compore_num(
                                                scene.new[d_index].data?.[i],
                                                scene.old[d_index].data?.[i],
                                                i
                                              )[0] || "--"), 5)
                                                        ]))
                                                      }), 128)),
                                                      _createVNode("tr", null, [
                                                        _createVNode("td", null, [
                                                          _createVNode("a", {
                                                            target: "_blank",
                                                            href: 
                                                _ctx.get_url(
                                                  scene.old[d_index].data?.url
                                                )
                                              
                                                          }, "链接", 8, ["href"])
                                                        ]),
                                                        _createVNode("td", null, [
                                                          _createVNode("a", {
                                                            target: "_blank",
                                                            href: 
                                                _ctx.get_url(
                                                  scene.new[d_index].data?.url
                                                )
                                              
                                                          }, "链接", 8, ["href"])
                                                        ]),
                                                        _hoisted_91
                                                      ])
                                                    ])
                                                  ]))
                                                }), 128))
                                              ])
                                            ])
                                          ])
                                        ])
                                      ])
                                    ])
                                  ])
                                ], 512)), [
                                  [_directive_loading, _ctx.loading]
                                ])
                              }), 128))
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_92, [
                              _createVNode(_component_el_empty, { description: "无数据" })
                            ]))
                      ])
                    ])
                  ])
                ]),
                _hoisted_93
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})